(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casida-daily-price"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('casida-daily-price')) return;

    class CasidaDailyPrice extends HTMLElement {
      static number(value) {
        if (typeof value === 'string') {
          if (!/^[+-]?\d+(?:\.\d+)?$/.test(value.trim())) return NaN;
          value = Number(value);
        }
        return typeof value === 'number' && Number.isFinite(value) ? value : NaN;
      }

      static measurementFor(config, variant) {
        if (!variant?.id) return null;
        const entry = config.variants?.find((item) => String(item.variantId) === String(variant.id));
        if (entry) return entry.measurement;
        if (String(variant.id) === String(config.variant?.id)) return config.measurement;
        return variant.unit_price_measurement || null;
      }

      static calculate(config, measurement, priceCents, packs) {
        const number = this.number;
        if (config.doseType !== 'list.number_decimal' || !Array.isArray(config.dose) || config.dose.length === 0) return null;
        const doses = config.dose.map(number);
        if (doses.some((value) => !(value > 0))) return null;
        const dose = Math.min(...doses);
        if (!(number(priceCents) > 0) || !Number.isSafeInteger(packs) || packs < 1) return null;

        let contents;
        const hasCapsules = config.capsules !== null && config.capsules !== undefined && config.capsules !== '';
        if (hasCapsules) {
          contents = number(config.capsules);
          if (config.capsulesType !== 'number_integer' || !Number.isSafeInteger(contents) || contents < 1) return null;
        } else {
          contents = number(measurement?.quantity_value);
          if (!(contents > 0)) return null;
          if (measurement.quantity_unit === 'ml') contents /= 0.05;
          else if (measurement.quantity_unit !== 'g') return null;
        }

        const days = contents * packs / dose;
        const centsPerDay = priceCents / days;
        if (!Number.isFinite(days) || days <= 0 || !Number.isFinite(centsPerDay) || centsPerDay <= 0) return null;
        // Casida: Erst das Endergebnis runden; Auslöschung an einer halben Cent-Grenze abfangen.
        const roundedCents = Math.floor(centsPerDay + 0.5 + Number.EPSILON * centsPerDay * 4);
        return { days, centsPerDay, roundedCents, multipleDoses: doses.length > 1 };
      }

      connectedCallback() {
        // Casida: Auch bei nachgeladenen Sections erst das vollständige Element lesen.
        queueMicrotask(() => this.connect());
      }

      connect() {
        if (!this.isConnected || this.controller) return;
        try {
          this.config = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
          this.formatter = new Intl.NumberFormat(this.config.locale || 'de-DE', {
            style: 'currency', currency: this.config.currency, minimumFractionDigits: 2, maximumFractionDigits: 2
          });
          const currencyDigits = new Intl.NumberFormat('en', { style: 'currency', currency: this.config.currency }).resolvedOptions().maximumFractionDigits;
          if (currencyDigits !== 2) return;
        } catch { return; }

        this.info = this.closest('.product__info');
        this.container = this.closest('.product-meta__price-list-container');
        if (!this.info || !this.container) return;
        this.variant = this.config.variant;
        this.measurement = CasidaDailyPrice.measurementFor(this.config, this.variant);
        this.badge = document.createElement('span');
        this.badge.className = 'casida-daily-price-badge';
        this.badge.hidden = true;
        this.badge.style.setProperty('--casida-daily-background', this.dataset.background || '#527e20');
        this.badge.style.setProperty('--casida-daily-color', this.dataset.color || '#ffffff');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        document.addEventListener('variant:changed', (event) => {
          if (event.target.getAttribute?.('id') !== this.dataset.formId) return;
          this.variant = event.detail?.variant || null;
          this.measurement = CasidaDailyPrice.measurementFor(this.config, this.variant);
          this.badge.hidden = true;
          this.schedule();
        }, options);
        this.info.addEventListener('casida:price:changed', (event) => {
          const list = this.container.querySelector('[data-product-price-list]');
          if (list) list.dataset.casidaPriceState = JSON.stringify(event.detail || {});
        }, options);
        for (const type of ['input', 'change']) {
          document.addEventListener(type, (event) => {
            if (event.target.form?.getAttribute('id') === this.dataset.formId || this.info.contains(event.target)) this.schedule();
          }, options);
        }
        window.addEventListener('resize', () => this.schedule(), options);
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => {
            if (this.badge.contains(record.target)) return false;
            if (record.type === 'attributes' && ['class', 'style', 'hidden', 'aria-hidden'].includes(record.attributeName)) {
              return this.container.contains(record.target) || record.target.contains(this.container);
            }
            return true;
          })) this.schedule();
        });
        this.observer.observe(this.info, {
          childList: true, subtree: true, characterData: true, attributes: true,
          attributeFilter: ['data-casida-price-state', 'value', 'checked', 'selected', 'class', 'style', 'hidden', 'aria-hidden']
        });
        this.schedule();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        this.badge?.remove();
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }

      displayedCents(priceNode) {
        // Casida: Nur Abgleich mit dem sichtbaren Preis; die Packungszahl kommt aus dem Preissystem.
        const copy = priceNode.cloneNode(true);
        copy.querySelectorAll('.visually-hidden, [aria-hidden="true"]').forEach((node) => node.remove());
        let text = copy.textContent.replace(/[\s\u00a0\u202f]/g, '');
        const formats = [window.themeVariables?.settings?.moneyFormat, window.elbDevCustom?.moneyFormat].filter(Boolean);
        const comma = formats.length ? formats.some((format) => format.includes('comma_separator')) : this.config.locale?.startsWith('de');
        text = text.replace(/[^\d.,'-]/g, '');
        if (comma) text = text.replace(/[.']/g, '').replace(',', '.');
        else text = text.replace(/[,'\u2019]/g, '');
        const amount = CasidaDailyPrice.number(text);
        return amount > 0 ? Math.round(amount * 100) : NaN;
      }

      hasVisibleDiscountLabel() {
        return Array.from(this.container.querySelectorAll('.label--highlight')).some((label) => {
          if (!label.textContent.trim() || !label.getClientRects().length) return false;
          for (let node = label; node && this.info.contains(node); node = node.parentElement) {
            const style = getComputedStyle(node);
            if (node.hidden || style.display === 'none' ||
                style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
          }
          return true;
        });
      }

      update() {
        this.badge.hidden = true;
        const list = this.container.querySelector('[data-product-price-list]');
        const priceNode = list?.querySelector(':scope > .price:not(.price--compare):not(.text--subdued)');
        if (!priceNode || !this.variant || list.hidden || getComputedStyle(list).display === 'none') return;

        let state;
        try { state = JSON.parse(list.dataset.casidaPriceState || '{}'); } catch { return; }
        const number = CasidaDailyPrice.number;
        let priceCents = number(state.priceCents);
        let packs = number(state.coveredPacks);
        if (String(state.variantId) !== String(this.variant.id)) return;
        const visibleCents = this.displayedCents(priceNode);
        const form = document.getElementById(this.dataset.formId);
        const formData = form ? new FormData(form) : null;
        const planId = String(formData?.get('selling_plan') || '');

        if (planId) {
          if (String(state.sellingPlanId || '') !== planId) {
            const plan = this.config.variants.find((entry) => String(entry.variantId) === String(this.variant.id))?.allocations.find((entry) => String(entry.id) === planId);
            const quantity = number(formData?.get('quantity') || 1);
            if (!plan || !Number.isSafeInteger(quantity) || quantity < 1) return;
            const perDelivery = number(plan.perDeliveryPrice);
            const upfront = number(plan.price);
            if (!(perDelivery > 0) || !(upfront > 0)) return;
            // Casida: Standard-Abos und Vorauszahlung nur bei eindeutig passendem sichtbarem Betrag.
            if (visibleCents !== Math.round(upfront * quantity) && visibleCents !== Math.round(perDelivery * quantity)) return;
            priceCents = perDelivery * quantity;
            packs = quantity;
          } else if (visibleCents !== Math.round(priceCents)) return;
        } else {
          if (this.config.requiresSellingPlan || state.sellingPlanId) return;
          if (String(state.variantId) !== String(this.variant.id) || visibleCents !== Math.round(priceCents)) return;
        }

        const result = CasidaDailyPrice.calculate(this.config, this.measurement, priceCents, packs);
        if (!result) return;
        const amount = this.formatter.format(result.centsPerDay < 1 ? 0.01 : result.roundedCents / 100);
        let prefix = (result.centsPerDay < 1 ? this.dataset.under : this.dataset.prefix) || '';
        if (result.multipleDoses) {
          prefix = ['ab', prefix.replace(/^(Nur|Unter)\b/u, (word) => word.toLocaleLowerCase('de-DE'))].filter(Boolean).join(' ');
        }
        const text = [prefix, amount, this.dataset.suffix].filter(Boolean).join(' ');
        if (this.badge.textContent !== text) this.badge.textContent = text;
        const showAsText = this.hasVisibleDiscountLabel();
        this.badge.classList.toggle('casida-daily-price-badge--text', showAsText);
        if (showAsText) {
          if (list.lastElementChild !== this.badge) list.append(this.badge);
        } else if (priceNode.nextElementSibling !== this.badge) priceNode.after(this.badge);
        this.badge.hidden = false;
      }
    }

    customElements.define('casida-daily-price', CasidaDailyPrice);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('casida-nem-packs')) return;
  const imageMeasurements = new Map();

  class CasidaNemPacks extends HTMLElement {
    static number(value) {
      if (typeof value === 'string' && /^\d+(?:\.\d+)?$/.test(value.trim())) value = Number(value);
      return typeof value === 'number' && Number.isFinite(value) ? value : NaN;
    }

    static calculate(config, variant, packs) {
      const number = this.number;
      if (!variant || ![1, 2, 3].includes(packs)) return null;
      const price = number(variant.price);
      if (!Number.isSafeInteger(price) || price <= 0) return null;
      let doses;
      if (config.doseType === 'list.number_decimal' && Array.isArray(config.dose)) doses = config.dose.map(number);
      else if (config.doseType === 'number_decimal' || config.doseType === 'number_integer') doses = [number(config.dose)];
      if (!doses?.length || doses.some(dose => !(dose > 0))) return null;
      let contents;
      const hasCapsules = config.capsules !== null && config.capsules !== undefined && config.capsules !== '';
      if (hasCapsules) {
        contents = number(config.capsules);
        if (config.capsulesType !== 'number_integer' || !Number.isSafeInteger(contents) || contents <= 0) return null;
      } else {
        contents = number(variant.quantity);
        if (!(contents > 0)) return null;
        if (variant.unit === 'ml') contents /= 0.05;
        else if (variant.unit !== 'g') return null;
      }
      const daysMin = contents * packs / Math.min(...doses);
      const daysMax = daysMin;
      if (![daysMin, daysMax].every(days => Number.isFinite(days) && days > 0 && days < Number.MAX_SAFE_INTEGER)) return null;
      const discount = [0, 0, 5, 10][packs];
      const numerator = price * packs * (100 - discount);
      if (!Number.isSafeInteger(numerator + 50)) return null;
      const total = Math.floor((numerator + 50) / 100);
      const reference = number(variant.compare) > price ? number(variant.compare) : price;
      if (!Number.isSafeInteger(reference * packs) || total <= 0) return null;
      return { total, reference, discount, saving: reference * packs - total,
        unitPrice: Math.floor((total / packs) + 0.5), approximate: total % packs !== 0,
        percent: (1 - total / (reference * packs)) * 100, daysMin, daysMax, hasCapsules };
    }

    static duration(days) {
      const whole = Math.floor(days + Number.EPSILON * Math.max(1, days) * 8);
      if (whole < 1) return 'weniger als 1 Tag';
      if (whole < 15) return `${whole} ${whole === 1 ? 'Tag' : 'Tage'}`;
      const months = Math.round(days / 15) / 2;
      if (months === 0.5) return '½ Monat';
      return `${String(months).replace('.', ',')} ${months === 1 ? 'Monat' : 'Monate'}`;
    }

    static setText(node, text) {
      if (node.textContent !== text) node.textContent = text;
    }

    static measureImage(url) {
      if (!imageMeasurements.has(url)) imageMeasurements.set(url, new Promise(resolve => {
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onerror = () => resolve(null);
        image.onload = () => {
          const naturalWidth = image.naturalWidth, naturalHeight = image.naturalHeight;
          const full = { left: 0, top: 0, width: 1, height: 1, ratio: naturalWidth / naturalHeight };
          try {
            // Casida: Sichtbare Grenzen einmalig messen; die hochgeladene Datei bleibt unverändert.
            const scale = Math.min(1, 320 / Math.max(naturalWidth, naturalHeight));
            const canvas = document.createElement('canvas');
            const width = canvas.width = Math.max(1, Math.round(naturalWidth * scale));
            const height = canvas.height = Math.max(1, Math.round(naturalHeight * scale));
            const context = canvas.getContext('2d', { willReadFrequently: true });
            context.drawImage(image, 0, 0, width, height);
            const pixels = context.getImageData(0, 0, width, height).data;
            const corners = [0, width - 1, (height - 1) * width, width * height - 1];
            const whiteBackground = corners.every(pixel => pixels[pixel * 4 + 3] > 250 &&
              pixels[pixel * 4] > 250 && pixels[pixel * 4 + 1] > 250 && pixels[pixel * 4 + 2] > 250);
            let left = width, top = height, right = -1, bottom = -1;
            for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) {
              const index = (y * width + x) * 4;
              if (pixels[index + 3] <= 8 || (whiteBackground && Math.min(pixels[index], pixels[index + 1], pixels[index + 2]) >= 248)) continue;
              left = Math.min(left, x); right = Math.max(right, x);
              top = Math.min(top, y); bottom = Math.max(bottom, y);
            }
            if (right < left || bottom < top) { resolve(full); return; }
            left = Math.max(0, left - 1); top = Math.max(0, top - 1);
            right = Math.min(width, right + 2); bottom = Math.min(height, bottom + 2);
            const cropWidth = (right - left) / width, cropHeight = (bottom - top) / height;
            resolve({ left: left / width, top: top / height, width: cropWidth, height: cropHeight,
              ratio: naturalWidth * cropWidth / (naturalHeight * cropHeight) });
          } catch { resolve(full); }
        };
        image.src = url;
      }));
      return imageMeasurements.get(url);
    }

    applyImageMeasurement(bounds) {
      this.style.setProperty('--nem-image-ratio', String(bounds.ratio));
      this.style.setProperty('--nem-image-width', `${100 / bounds.width}%`);
      this.style.setProperty('--nem-image-height', `${100 / bounds.height}%`);
      this.style.setProperty('--nem-image-left', `${-100 * bounds.left / bounds.width}%`);
      this.style.setProperty('--nem-image-top', `${-100 * bounds.top / bounds.height}%`);
    }

    connectedCallback() {
      this.controller = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.connect(), { once: true, signal: this.controller.signal });
      } else queueMicrotask(() => this.connect());
    }

    connect() {
      if (!this.isConnected || this.initialized) return;
      try {
        this.config = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.money = new Intl.NumberFormat(this.config.locale || 'de', { style: 'currency', currency: this.config.currency });
        if (this.money.resolvedOptions().maximumFractionDigits !== 2) return;
        this.numberFormat = new Intl.NumberFormat(this.config.locale || 'de', { maximumFractionDigits: 2 });
        this.percentFormat = new Intl.NumberFormat(this.config.locale || 'de', { maximumFractionDigits: 1 });
        this.unitMoney = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch { return; }
      this.info = this.closest('.product__info');
      this.scope = this.closest('[js-main-product]');
      this.form = document.getElementById(this.dataset.formId);
      if (!this.info || !this.scope || !this.form) return;
      this.original = [...this.parentElement.querySelectorAll('[js-stuck-item]')];
      if (this.original.length !== 3) return;
      const quantities = [...this.form.elements].filter(input => input.name === 'quantity' && !input.disabled);
      if (quantities.length !== 1) return;
      this.quantityInput = quantities[0];
      if (typeof window.theme?.Currency?.formatMoney !== 'function') return;
      this.hostPriceKey = undefined;
      this.renderKey = null;
      this.imageKey = null;
      this.radios = [...this.querySelectorAll('.casida-nem__radio')];
      this.cards = this.radios.map(radio => {
        const card = radio.nextElementSibling;
        return { radio, price: card.querySelector('[data-nem-price]'), old: card.querySelector('[data-nem-old]'),
          oldLabel: card.querySelector('[data-nem-old-label]'), badge: card.querySelector('[data-nem-badge]'),
          images: [...card.querySelectorAll('[data-nem-image]')] };
      });
      this.amountNode = this.querySelector('[data-nem-amount]');
      this.durationNode = this.querySelector('[data-nem-duration]');
      this.typeNodes = [...this.querySelectorAll('.casida-nem__name, .casida-nem__old, .casida-nem__price')];
      this.resizeObserver = new ResizeObserver(() => this.scheduleTypography());
      this.resizeObserver.observe(this.querySelector('.casida-nem__options'));
      document.fonts.ready.then(() => { if (this.isConnected) this.scheduleTypography(); });
      this.variant = this.config.variants.find(variant => String(variant.id) === String(this.config.variantId));
      this.initialized = true;
      const options = { signal: this.controller.signal };
      document.addEventListener('variant:changed', event => {
        if (event.target.getAttribute?.('id') !== this.dataset.formId) return;
        const next = event.detail?.variant;
        const stored = this.config.variants.find(variant => String(variant.id) === String(next?.id));
        this.variant = stored && next ? { ...stored, price: next.price, compare: next.compare_at_price, available: next.available } : null;
        this.hostPriceKey = null;
        this.failedImage = null;
        this.schedule();
      }, { ...options, capture: true });
      this.addEventListener('change', event => {
        if (!event.target.matches('.casida-nem__radio')) return;
        this.quantityInput = this.getQuantityInput();
        if (!this.quantityInput) { this.fallback(); return; }
        this.quantityInput.value = event.target.value;
        this.update(true);
      }, options);
      for (const type of ['input', 'change']) {
        document.addEventListener(type, event => {
          if (this.syncing || this.contains(event.target)) return;
          if (event.target.form === this.form || this.info.contains(event.target)) this.schedule();
        }, options);
      }
      document.addEventListener('ed:qty:change', () => { if (!this.syncing) this.schedule(); }, options);
      this.parentElement.addEventListener('click', event => {
        if (!this.syncing && event.target.closest('[js-stuck-item]')) this.schedule();
      }, options);
      this.addEventListener('error', event => {
        if (!event.target.matches('[data-nem-image]')) return;
        if (event.target.getAttribute('src') !== this.variant?.image) return;
        this.failedImage = event.target.getAttribute('src');
        this.fallback();
      }, { ...options, capture: true });
      this.addEventListener('load', event => {
        if (event.target.matches('[data-nem-image]') && !this.imageBoundsReady && event.target.naturalHeight > 0) {
          this.style.setProperty('--nem-image-ratio', String(event.target.naturalWidth / event.target.naturalHeight));
        }
      }, { ...options, capture: true });
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target) && (
          record.type === 'attributes' && record.target.matches('[name="selling_plan"], [name="quantity"]') ||
          record.type === 'childList' && [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('[name="selling_plan"], [name="quantity"]') || node.querySelector('[name="selling_plan"], [name="quantity"]')))
        ))) this.schedule();
      });
      this.observer.observe(this.info, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked', 'disabled'] });
      this.schedule();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.typeFrame);
      this.frame = null;
      this.typeFrame = null;
      this.initialized = false;
      this.fallback();
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
    }

    scheduleTypography() {
      if (this.typeFrame) return;
      this.typeFrame = requestAnimationFrame(() => {
        this.typeFrame = null;
        if (this.hidden) return;
        const current = Number(this.style.getPropertyValue('--nem-font-scale')) || 1;
        // Casida: Alle Textbreiten gemeinsam lesen; eine einheitliche Skalierung erhält die Preis-Hierarchie.
        const scale = Math.min(1, ...this.typeNodes.map(node => {
          const width = node.getBoundingClientRect().width;
          const card = node.parentElement;
          const style = getComputedStyle(card);
          const available = card.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight) - 1;
          return width > 0 ? available * current / width : 1;
        }));
        if (scale > 0 && Math.abs(scale - current) > .002) this.style.setProperty('--nem-font-scale', String(scale));
      });
    }

    fallback() {
      this.hidden = true;
      this.removeAttribute('data-active');
      this.hostPriceKey = null;
    }

    getQuantityInput() {
      if (!this.form.isConnected || document.getElementById(this.dataset.formId) !== this.form) return null;
      const inputs = [...this.form.elements].filter(input => input.name === 'quantity' && !input.disabled);
      return inputs.length === 1 ? inputs[0] : null;
    }

    formatUnitPrice(cents) {
      return this.config.currency === 'EUR' ? `€${this.unitMoney.format(cents / 100)}` : this.money.format(cents / 100);
    }

    formatThemeMoney(cents, includeCurrencyCode = true) {
      const settings = window.themeVariables?.settings || {};
      const format = includeCurrencyCode && settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
      return window.theme.Currency.formatMoney(cents, format || window.theme.settings?.moneyFormat);
    }

    static setPriceHTML(node, html) {
      // Casida: Shop-Geldformat ist HTML. Texte aktualisieren, ohne Geld-Wrapper oder Screenreader-Labels zu verwerfen.
      const template = document.createElement('template');
      template.innerHTML = html;
      const patch = (target, source) => {
        const current = [...target.childNodes].filter(child => child.nodeType !== 1 || !child.matches('.visually-hidden, [data-casida-price-preserve]'));
        const next = [...source.childNodes];
        next.forEach((replacement, index) => {
          const child = current[index];
          if (!child) { target.append(replacement.cloneNode(true)); return; }
          if (child.nodeType === replacement.nodeType && child.nodeName === replacement.nodeName) {
            if (child.nodeType === 1) {
              for (const attribute of replacement.attributes) {
                if (child.getAttribute(attribute.name) !== attribute.value) child.setAttribute(attribute.name, attribute.value);
              }
              patch(child, replacement);
            } else if (child.nodeValue !== replacement.nodeValue) child.nodeValue = replacement.nodeValue;
          } else child.replaceWith(replacement.cloneNode(true));
        });
        current.slice(next.length).forEach(child => child.remove());
      };
      patch(node, template.content);
    }

    update(notify = false) {
      this.quantityInput = this.getQuantityInput();
      if (!this.quantityInput) { this.fallback(); return; }
      const packs = CasidaNemPacks.number(this.quantityInput.value);
      const variant = this.variant;
      const plan = new FormData(this.form).get('selling_plan');
      const result = CasidaNemPacks.calculate(this.config, variant, packs);
      if (!result || !variant.image || this.failedImage === variant.image || !variant.available ||
          this.config.requiresSellingPlan || variant.requiresSellingPlan || plan || this.config.otherQuantityDiscount ||
          variant.priceBreaks > 0 || variant.minimum !== 1 || variant.increment !== 1 ||
          (variant.maximum !== null && variant.maximum !== undefined && variant.maximum < 3) || this.quantityInput.disabled) {
        this.fallback(); return;
      }
      const dynamic = this.parentElement.dataset.casidaDynamicDiscounts !== 'false';
      const renderKey = JSON.stringify([variant.price, variant.compare, variant.image, dynamic]);
      const pricesChanged = renderKey !== this.renderKey;
      if (variant.image !== this.imageKey) {
        this.imageKey = variant.image;
        this.imageBoundsReady = false;
        this.applyImageMeasurement({ left: 0, top: 0, width: 1, height: 1, ratio: variant.imageWidth > 0 && variant.imageHeight > 0 ? variant.imageWidth / variant.imageHeight : 1 });
        const imageUrl = variant.image;
        CasidaNemPacks.measureImage(imageUrl).then(bounds => {
          if (!bounds || !this.isConnected || this.variant?.image !== imageUrl) return;
          this.applyImageMeasurement(bounds);
          this.imageBoundsReady = true;
        });
      }
      for (const { radio, price, old, oldLabel, badge, images } of this.cards) {
        const quantity = Number(radio.value);
        radio.checked = quantity === packs;
        if (!pricesChanged) continue;
        const row = CasidaNemPacks.calculate(this.config, variant, quantity);
        CasidaNemPacks.setText(price, this.formatUnitPrice(row.unitPrice));
        CasidaNemPacks.setText(old, row.saving > 0 ? `${this.formatUnitPrice(row.reference)} / Stk` : '');
        oldLabel.hidden = row.saving <= 0;
        const percent = dynamic ? row.percent : row.discount;
        badge.hidden = percent <= 0;
        CasidaNemPacks.setText(badge, `−${this.percentFormat.format(percent)} %`);
        badge.title = dynamic ? `${this.money.format(row.saving / 100)} Gesamtersparnis gegenüber ${this.money.format(row.reference * quantity / 100)}` : `${percent} % Mengenrabatt auf den aktuellen Einzelpreis`;
        for (const image of images) {
          if (image.getAttribute('src') !== variant.image) image.src = variant.image;
        }
      }
      this.renderKey = renderKey;
      const measurement = CasidaNemPacks.number(variant.quantity);
      let amount = `${packs} × `;
      if (result.hasCapsules) amount += `${this.numberFormat.format(this.config.capsules)} Kapseln`;
      if (measurement > 0 && variant.unit) amount += `${result.hasCapsules ? ' / ' : ''}${this.numberFormat.format(measurement)} ${variant.unit}`;
      CasidaNemPacks.setText(this.amountNode, amount);
      CasidaNemPacks.setText(this.durationNode, `ca. ${CasidaNemPacks.duration(result.daysMin)}`);
      this.hidden = false;
      this.setAttribute('data-active', '');
      if (pricesChanged) this.scheduleTypography();
      this.sync(packs, result, notify);
    }

    sync(packs, result, notify) {
      this.syncing = true;
      try {
        const selected = this.original.find(item => Number(item.dataset.quantity) === packs);
        // Casida: Bestehende Auswahl-Hooks synchronisieren; fremde Preisknoten nicht durch den alten Klickpfad ersetzen.
        this.original.forEach(item => item.classList.toggle('active', item === selected));
        this.parentElement.querySelectorAll('[js-spare-label]').forEach((label, index) => label.classList.toggle('active', index === packs - 1));
        const meter = this.parentElement.querySelector('[js-spare-meter-bar]');
        if (meter) meter.style.width = `${packs / 3 * 100}%`;
        this.quantityInput.value = String(packs);
        if (notify) {
          this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const state = { variantId: this.variant.id, priceCents: result.total, coveredPacks: packs, sellingPlanId: '' };
        const hostKey = JSON.stringify([state, this.variant.compare, this.variant.unitPrice]);
        // Casida: Das Aktivieren der Kacheln darf die bestehende Preisgestaltung nicht neu rendern.
        const renderPrices = this.hostPriceKey === undefined ? packs !== 1 : this.hostPriceKey !== hostKey;
        if (renderPrices) {
          const perServing = Number(String(this.config.perServing ?? '').replace(',', '.'));
          const servingNode = this.info.querySelector('[js-price-per-saving]');
          if (servingNode && perServing > 0) CasidaNemPacks.setPriceHTML(servingNode, this.formatThemeMoney(Math.round(perServing * (100 - result.discount)), false));
          const base = CasidaNemPacks.number(this.variant.unitPrice);
          const baseNode = this.info.querySelector('[js-base-price]');
          if (baseNode && base > 0) CasidaNemPacks.setPriceHTML(baseNode, this.formatThemeMoney(Math.round(base * (100 - result.discount) / 100), false));
        }
        const lists = [...this.scope.querySelectorAll('[js-product-price-list]')].filter(list =>
          list.closest('product-meta, product-sticky-form')?.getAttribute('form-id') === this.dataset.formId);
        for (const list of lists) {
          if (!renderPrices) { list.dataset.casidaPriceState = JSON.stringify(state); continue; }
          // Casida: Bestehende Preisknoten aktualisieren, um unnötige DOM-Wechsel und App-Neuinitialisierungen zu vermeiden.
          let price = list.querySelector(':scope > .price:not(.price--compare):not(.text--subdued)');
          if (!price) { price = document.createElement('span'); price.className = 'price price--large'; list.prepend(price); }
          price.classList.add('price--highlight');
          price.classList.toggle('regular-price', result.saving <= 0);
          CasidaNemPacks.setPriceHTML(price, this.formatThemeMoney(result.total));
          let compare = list.querySelector(':scope > .price--compare');
          let saving = list.querySelector(':scope > .product-meta__label-list');
          if (result.saving > 0) {
            if (!compare) { compare = document.createElement('s'); compare.className = 'price price--compare'; price.after(compare); }
            compare.setAttribute('aria-label', `Vergleichspreis ${this.money.format(result.reference * packs / 100)}`);
            CasidaNemPacks.setPriceHTML(compare, this.formatThemeMoney(result.reference * packs));
            if (!saving) {
              saving = document.createElement('span');
              saving.className = 'product-meta__label-list label-list';
              saving.setAttribute('data-product-label-list', '');
              compare.after(saving);
            }
            // Casida: Nur den Labeltext aktualisieren; Klassen und Wrapper für Theme und Tagespreis erhalten.
            let savingLabel = saving.querySelector(':scope > .label--highlight');
            if (!savingLabel) {
              savingLabel = document.createElement('span');
              savingLabel.className = 'label label--highlight';
              saving.replaceChildren(savingLabel);
            }
            CasidaNemPacks.setPriceHTML(savingLabel, `Du sparst ${this.formatThemeMoney(result.saving)}`);
          } else {
            compare?.remove();
            saving?.remove();
          }
          list.dataset.casidaPriceState = JSON.stringify(state);
        }
        this.hostPriceKey = hostKey;
        this.info.dispatchEvent(new CustomEvent('casida:price:changed', { bubbles: true, detail: state }));
      } finally { this.syncing = false; }
    }
  }
  customElements.define('casida-nem-packs', CasidaNemPacks);
})();

// Casida: Rabatttexte aktualisieren; vorhandene Preis- und Mengenaktionen unverändert lassen.
(() => {
  if (window.casidaPackPercentagesBound) return;
  window.casidaPackPercentagesBound = true;
  document.addEventListener('variant:changed', event => {
    const info = event.target.closest?.('.product__info');
    if (!info) return;
    const meta = info.querySelector('product-meta');
    if (meta?.getAttribute('form-id') !== event.target.getAttribute('id')) return;
    const variant = event.detail?.variant;
    requestAnimationFrame(() => {
      const labels = info.querySelectorAll('.product-stucks-block > .spare-header [js-spare-label]');
      if (labels.length !== 3) return;
      const price = Number(variant?.price);
      const compare = Number(variant?.compare_at_price);
      const dynamic = info.querySelector('[data-casida-quantity]')?.dataset.casidaDynamicDiscounts !== 'false';
      const format = new Intl.NumberFormat('de', { maximumFractionDigits: 1 });
      labels.forEach((label, index) => {
        if (!(dynamic && price > 0 && compare > price) && index === 0) {
          label.textContent = 'Menge:'; return;
        }
        const quantity = index + 1;
        const total = Math.floor((price * quantity * [100, 95, 90][index] + 50) / 100);
        const percent = dynamic && price > 0 && compare > price ? (1 - total / (compare * quantity)) * 100 : [0, 5, 10][index];
        label.textContent = `${format.format(percent)} % sparen`;
      });
    });
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
